(function () {
    "use strict";

    angular.module("app").component("habilOrganisationJustification", {
        templateUrl: '@/organisation/organisation-justification.template.html',
        bindings: {
            justification: '=',
            organisationName: '<'
        },
        controller: function () { }
    });
})();